<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
                <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-4 col-4">
                    <h2>Rejected Offers</h2>
                    </div>
                    <div class="col-lg-8 col-8 text-right bid">
                        <!-- <button  @click="openAddNewCusipModal()" type="button" class="btn btn-success"><i class="fas fa-user-plus"></i> ADD NEW CUSIP</button> -->
                        <form @submit.prevent="" class="d-inline-block justify-content-center headSearch mr-2">
                        <i @click="searchOffer()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                        <input v-on:keyup.enter="searchOffer" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm" type="text" placeholder="Search offer" aria-label="Search">
                        <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
                        </form>
                        <!-- <button @click="openImportCustomerModal()" type="button" class="btn btn-danger rounded"><i class="far fa-minus-square"></i> Remove All</button> -->
                    </div>
                </div>
                <!-- Card stats -->
                </div>
            </div>
        </div>
        <div class="container-fluid mt--6 filter-show">
          <div class="card w-100 p-2 mb-2  d-inline-block">
            <div class="d-flex justify-content-between">
              <h5 class="ml-3">Filters</h5>
              <span class="btn btn-link" @click="showFilters = !showFilters">
                <i class="fa" v-bind:class="[showFilters ? 'fa-angle-up' : 'fa-angle-down']" ></i> {{showFilters ? 'Hide' : 'Show'}} Filters
              </span>
            </div>
            <div class="row" v-if="showFilters">
              <div class="col-lg-12">
                <form class="row">
                    <div class="col-md-6 col-lg-3">
                      <label for="filter" class="col-form-label">From</label>
                      <datepicker v-model="fromDate"  name="fromDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                    </div>
                    <div class="col-md-6 col-lg-3">
                      <label for="filter" class="col-form-label">To</label>
                      <datepicker v-model="toDate"  name="toDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                    </div>
                    <div class="col-md-2">
                      <button @click="searchOffer()" type="button" class="btn btn-primary rounded">Filter</button>
                    </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid">
            <div class="row xsOnly">
                <div class="col-xl-12">
                <div class="card scrollbar vh-75" id="scroll">
                    <div class="table-responsive">
                    <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                    <table class="table align-items-center table-flush table-hover bidtbl">
                        <thead class="thead-light psticky">
                        <tr >
                            <th 
                          scope="col" 
                          class="sort"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cusip'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cusip'  ? 'sort-desc' : '']"  
                          @click="sort('cusip')">CUSIP/DESC</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'quantity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'quantity'  ? 'sort-desc' : '']"  
                          @click="sort('quantity')">QTY</th>
                          <th
                            scope="col"
                            class="sort text-center"
                            v-bind:class="[sortOrder == 'ASC' && sortColumn == 'quantity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'quantity'  ? 'sort-desc' : '']"  
                            @click="sort('quantity')">Fill/Rem
                            </th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'price'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'price'  ? 'sort-desc' : '']"  
                          @click="sort('price')">PRICE</th>
                          <!-- <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'offerValidity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'offerValidity'  ? 'sort-desc' : '']"  
                          @click="sort('offerValidity')">OFFER <br> VALIDITY</th> -->
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'offerType'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'offerType'  ? 'sort-desc' : '']"  
                          @click="sort('offerType')">OFFER <br>  TYPE</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'coupon'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'coupon'  ? 'sort-desc' : '']"  
                          @click="sort('coupon')">COUPON</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cost'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cost'  ? 'sort-desc' : '']"  
                          @click="sort('cost')">COST</th>
                          <th
                          scope="col"
                          class="sort text-left">TMC<br>Status/Price
                          </th>
                          <th
                          scope="col"
                          class="sort text-left">TWR<br>Status/Price
                          </th>
                          <th
                          scope="col"
                          class="sort text-left">KBP<br>Status/Price
                          </th>
                          <th
                          scope="col"
                          class="sort text-left">MKTX<br>Status/Price
                          </th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'yield'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'yield'  ? 'sort-desc' : '']"  
                          @click="sort('yield')">YIELD</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'yieldSpread'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'yieldSpread'  ? 'sort-desc' : '']"  
                          @click="sort('yieldSpread')">SPREAD</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'balance'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'balance'  ? 'sort-desc' : '']"  
                          @click="sort('balance')">BAL/MIN/INC</th>
                            <th scope="col" class="text-center">REJECT REASON</th>
                        </tr>
                        </thead>
                        <tbody class="list">
                        <tr v-if="totalRows == 0 && !loading">
                            <td><p class="nodata">No data available</p>
                            </td>
                        </tr>
                        <tr v-for="(offer,i) in offerings" :key="i" v-bind:class="{'active-row': offer.isActive}">
                            <td>
                              <span class="cusips"><i class="fas fa-info-circle"></i> {{offer.cusipVal}}</span>
                              <span class="desc">{{offer.cusipDescription}}</span>
                          </td>
                          <td class="text-center">
                              <span>{{offer.quantity}}</span><br>
                          </td>
                           <td class="text-center">
                              <span class="mr-3 d-inline-block">Fill<br><span class="text-danger d-block">{{offer.executedQuantity || 0}}</span></span>
                              <span class="d-inline-block">REM<br><span class="text-success d-block">{{(offer.quantity - offer.executedQuantity) || 0}}</span></span>
                          </td>
                          <td class="text-center">
                              <span>{{offer.price | currency }}   </span><br>
                          </td>
                          <!-- <td class="text-center">
                              <span>{{offer.offerValidity}}</span><br>
                          </td> -->
                          <td class="text-center">
                              <span>{{offer.offerType}}</span><br>
                          </td>
                          <td class="text-center">
                              <span>{{offer.coupon |  percent(3)}}</span><br>
                          </td>
                          <td class="text-center">
                              <span>{{offer.cost | currency}}</span><br>
                          </td>
                          <td class="text-left">
                              <span class="border rounded-pill px-2 py-1 mr-2" v-bind:title="getEcnStatus(offer.tmcStatus).message" v-bind:class="getEcnStatus(offer.tmcStatus).className">{{getEcnStatus(offer.tmcStatus).status}}</span>
                              <span class="text-primary">{{offer.tmcprice | currency}}</span>
                          </td>
                          <td class="text-left">
                              <span class="border rounded-pill px-2 py-1 mr-2" v-bind:title="getEcnStatus(offer.twdStatus).message" v-bind:class="getEcnStatus(offer.twdStatus).className">{{getEcnStatus(offer.twdStatus).status}}</span>
                              <span class="text-primary">{{offer.twdprice | currency}}</span>
                          </td>
                          <td class="text-left">
                              <span class="border rounded-pill px-2 py-1 mr-2" v-bind:title="getEcnStatus(offer.ibpStatus).message" v-bind:class="getEcnStatus(offer.ibpStatus).className">{{getEcnStatus(offer.ibpStatus).status}}</span>
                              <span class="text-primary">{{offer.ibpprice | currency}}</span>
                          </td>
                          <td class="text-left">
                              <span class="border rounded-pill px-2 py-1 mr-2" v-bind:title="getEcnStatus(offer.mktxStatus).message" v-bind:class="getEcnStatus(offer.mktxStatus).className">{{getEcnStatus(offer.mktxStatus).status}}</span>
                              <span class="text-primary">{{offer.mktxPrice | currency}}</span>
                          </td>
                          <td class="text-center">
                              <span>{{offer.yield ? offer.yield+' %'  : 'N/A'}}</span>
                          </td>
                          <td class="text-center">
                              <span>{{(offer.price - offer.cost).toFixed(3)}}</span>
                          </td>
                          <td class="text-center">
                              <span>{{offer.balance}} - {{offer.minimum}} - {{offer.incrementVal}}</span>
                          </td>
                            <td class="text-center">
                              <!-- <button class="btn ibtn btn-outline-success" title="Move to MSRB"><i class="fas fa-reply"></i></button> -->
                                <button @click="getOfferDetails(offer)" class="btn ibtn btn-outline-danger" title="Reject reason"><i class="far fa-comments"></i></button>
                                <!-- <button class="btn ibtn btn-outline-danger" title="Delete"><i class="far fa-trash-alt"></i></button> -->
                            </td>
                            </tr>
                        </tbody>
                    </table>
                    <!-- Pagination-->
                    <b-pagination
                        class="mt-4"
                        :total-rows="totalRows"
                        v-model="currentPage"
                        :per-page="perPage"
                        @input="getOfferList(currentPage)"
                    ></b-pagination>
                    <div class="total-records">
                        <span>Total Records : {{totalRows}}</span>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </div>  
        <rejectedReason
          v-bind:offer="selectedOffer"
          @close="selectedOffer = null"
          v-if="selectedOffer"
        ></rejectedReason>
    </div> 
      
</template>
<script>
import config from "@/config";
import authService from "@/authService";
import stateConstants from "@/stateConstants";
import rejectedReason from "./ImsRejectedReasonTrade";
import Datepicker from 'vuejs-datepicker';
import ecnStatus from "@/ecnStatus";

export default {
  name: "imsOfferRejectedListComponent",
  components : {
    rejectedReason,
    Datepicker
  },
  data() {
    return {
        accessToken: null,
        config: config,
        loading : false,
        currentPage: 1,
        perPage: 10,
        searchValue : "",
        totalRows : 0,
        selectedCusip : "",
        sortColumn: "latestDate",
        sortOrder: "ASC",
        stateConstants: stateConstants,
        offerings:[],
        selectedOffer : null,
        fromDate : "",
        toDate : "",
        showFilters : false,
        ecnStatus : ecnStatus,
        isAdmin: false,
        isTrader : false,
        isEditor : false,
        isSuperAdmin : false,



    };
  },
  methods: {
    getEcnStatus(ecnStatus){
      var ecnData = this.ecnStatus.find(x => x.status === ecnStatus);
      if(ecnData){
        var className = ecnData.type == 'error'  ? 'border-warning text-error' : 'border-success text-success';
        return  { className : className ,status : ecnStatus,message : ecnData.message }
      }else{
        return  { className : 'border-success text-success' ,status : ecnStatus, message : "" }
      }
    },
    searchOffer(){
      this.getOfferList(); 
    },
    clearSearch(){
      this.searchValue = "";
      this.getOfferList(); 
    },
    sort(column){
      this.sortColumn = column;
      this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
      this.getOfferList();
    },
    getStateName(id){
      return id ? this.stateConstants.find(x => x.id === id).short : 'N/A';
    },
    getOfferDetails(offerSelected){
      this.offerings.forEach(function(offer) {
        offer.isActive = false;
      });
      offerSelected.isActive = true;
      this.selectedOffer = offerSelected;
    },
    getOfferList(currentPage) {
      this.loading = true;
      if (!currentPage) {
        currentPage = 1;
      }
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      //console.log(this.moment(this.toDate).format("YYYY-MM-DD HH:mm:ss"))
      //console.log(this.moment.utc(this.toDate).add(1,"days").format("YYYY-MM-DD HH:mm:ss"))
      //console.log(this.moment.utc(this.fromDate).format("YYYY-MM-DD HH:mm:ss"))


      var fDate = this.fromDate ? this.moment(this.fromDate).utc().format("YYYY-MM-DD HH:mm:ss") : "";
      var tDate = this.toDate ? this.moment(this.toDate).add(1,"days").utc().format("YYYY-MM-DD HH:mm:ss") : "";
      let cognitoSub = this.isTrader && (!this.isAdmin || !this.isEditor) ? authService.getUser().cognitoSub : "";

      this.$http
        .get(
          config.baseUrlBidSide +
            "/offer/list-by-ecn?page=" +
            currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status=NEW,SUSPEND,SUCCESS,TRADER_FILL,WAITING_EXECUTION,HOLD,MSRB"+
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder+
            "&ecnStatus=REJECTED"+
            "&fromDate="+
            fDate+
            "&toDate="+
            tDate+
            "&cognitoSub=" +
            cognitoSub,
            auth

        )
        .then(result => {
          //console.log(result);
          this.totalRows = result.data.pageInfo.totalElements;
        //   result.data.content.forEach(function(cusip) {
        //    cusip.isActive = false;
        //   });
           this.offerings = result.data.content;
           this.loading = false;
        })
        .catch(e => {
          console.log("Error", e);
          //self.loading = false;
        });
    }
  },
  mounted() {
    this.fromDate = this.moment().subtract(2,"days").format("MM-DD-YYYY");
    this.toDate = this.moment().format("MM-DD-YYYY");
    this.$cognitoAuth.getUserGroup((err, role) => {
        if (err) {
          console.log("accessToken is not found", err);
        } else {
          var roleArray = role.map(item => {
            return  item.split("-")[1];
          })
          roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
          roleArray.includes('Trader')  ? this.isTrader = true : this.isTrader = false;
          roleArray.includes('Editor')  ? this.isEditor = true : this.isEditor = false;
          roleArray.includes('SuperAdmin')  ? this.isSuperAdmin = true : this.isSuperAdmin = false;
          this.getOfferList();
        }
    });

  }
};
</script>